<script setup lang="ts">
// DashboardSection - Wraps dashboard cards with title and controller area
defineProps<{
  title: string
}>()
</script>

<template>
  <div class="dashboard-section">
    <!-- Title Area -->
    <div class="flex items-center gap-4 mb-6">
      <!-- Left: Title -->
      <h2 class="text-[11px] uppercase tracking-wide font-medium text-neutral-500 dark:text-neutral-500 whitespace-nowrap">
        {{ title }}
      </h2>

      <!-- Center: Horizontal Line -->
      <div class="flex-1 border-t border-neutral-200 dark:border-neutral-700"></div>

      <!-- Right: Controller Area -->
      <div v-if="$slots.controller">
        <slot name="controller" />
      </div>
    </div>

    <!-- Body Area -->
    <div>
      <slot />
    </div>
  </div>
</template>
